@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;

$blue: v.$palette-blue;
$grey: v.$palette-gray-300;
$dark: v.$palette-gray-900;

.container {
  position: absolute;
  display: none;
  z-index: v.$z-index-toggle-button-panel;
  bottom: max(16px, env(safe-area-inset-bottom, 0px));
  left: 50%;
  transform: translateX(-50%);
  width: min(320px, calc(100% - 24px));

  @include c.containerMedia(v.$js-defined-mobile-breakpoint) {
    display: block;
  }
}

.containerFiller {
  position: relative;

}

.filler {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 50%;
  border-radius: 6px;
  transition: all .2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  @include t.text(14px, 22px, 600);
  color: v.$palette-pure-white;
}

.variantSea {
  .buttonBox {
    box-shadow: v.$shadow-sea-tracking;
  }

  .filler {
    background-color: v.$palette-sea-tracking;
  }
}

.variantAir {
  .buttonBox {
    box-shadow: v.$shadow-air-tracking;
  }

  .filler {
    background-color: v.$palette-air-tracking;
  }
}

.variantGlobal {
  .buttonBox {
    box-shadow: v.$shadow-global-tracking;
  }

  .filler {
    background-color: v.$palette-global-tracking;
  }
}

.fillerRight {
  left: 50%;
}

.buttonBox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 1px solid $grey;
  border-radius: 6px;
  background: v.$palette-white;
}

.switchButton {
  font-family: v.$primary-font;
  border-radius: 6px;
  border: none;
  padding: 10px 0;
  flex: 1 1 50%;
  width: 50%;
  color: $dark;
  background: v.$palette-white;
  @include t.text(14px, 16px, 600);
}
